const SUPABASE_URL = 'https://dgxnnwnugdxzeopleera.supabase.co'
const SUPABASE_ANON_KEY =
  'sb_publishable_Uvr3BAwELJRoqXHFs7x7kQ_u2HCxSgm'

/** Fire-and-forget failed-login telemetry (no password; never blocks UX). */
export function reportLoginFailure(email: string | undefined, app: string): void {
  const normalized = email?.trim().slice(0, 320) || null
  fetch(`${SUPABASE_URL}/functions/v1/report-login-failure`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
    },
    body: JSON.stringify({ email: normalized, app }),
  }).catch(() => {})
}
